export const BACKDROP_CONSTANTS = {
  SHOW_BACKDROP: 'SHOW_BACKDROP',
  HIDE_BACKDROP: 'HIDE_BACKDROP',
};

export const BACKDROP_TYPES = {
  SPLASH: 'SPLASH',
  SIMPLE_BACKDROP: 'SIMPLE_BACKDROP',
};
